module.exports = __webpack_public_path__ + "static/media/4.fb526d6d.jpeg";